export default "__VITE_ASSET__C336oXR7__"